import axios from '../utils/axios';

export default function updateClient(adminId,recId, data) {
    return (
        axios.post('/admin/' + adminId +'/update-client/' + recId,  data )
    )
}